import React, {useEffect, Fragment, ReactNode} from 'react';
import {setCurrent} from 'js/tool/page/current';
import 'js/tool/i18n';
import {useTranslation} from 'react-i18next';

type IProps = {
	children: ReactNode
}

function TranslationsInitializer({children}: IProps) {
	const {t, i18n} = useTranslation();
	useEffect(() => {
		setCurrent.translator(t);
		i18n.changeLanguage('en');
	}, []);

	if (!i18n.language) {
		return <Fragment />;
	}

	return (
		<Fragment key={i18n.language}>
			{children}
		</Fragment>
	);
}

export default TranslationsInitializer;

/**
 * If updating/refactoring anything related to translations funcionality, 
 * please also update the docs at: https://alephrnd.atlassian.net/wiki/spaces/TECHD/pages/335020166/Internationalization
 */
